module.exports = __webpack_public_path__ + "statics/img/cate9-2@2x.0c22e0a4.png";